import React from 'react';
import { List, Edit, Create, Delete,
     DateField, BooleanField,BooleanInput,DeleteButton,
     Datagrid, TextField, EditButton, DisabledInput, NumberField, SimpleForm, TextInput} from 'admin-on-rest';

export const GetServers = (props) => (
    <List {...props}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="host" />
            <NumberField source="ram" />
            <NumberField source="cpu" />
            <NumberField source="net_in" />
            <NumberField source="net_out" />
            <NumberField source="cons" />
            <NumberField source="streams" />
            <BooleanField source="is_active" />
            <DateField source="stoped_at" showTime/>
            <EditButton />
        </Datagrid>
    </List>
);

export const CreateServer = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="host" required/>
        </SimpleForm>
    </Create>
);

const ServerTitle = ({ record }) => {
    return <span>Edit {record ? `"${record.host}"` : ''}</span>;
};

export const EditServer = (props) => (
    <Edit title={<ServerTitle />} {...props}>
        <SimpleForm>
            <DisabledInput source="id" />
            <TextInput source="host" />
            <BooleanInput source="is_active" />
        </SimpleForm>
    </Edit>
);



// WEBPACK FOOTER //
// ./src/servers.js